import SignUpForm from "../components/SignUpForm";

const SignUp = () => {
  return (
    <div>
      <SignUpForm />
    </div>
  );
};

export default SignUp;
